module.exports = __webpack_public_path__ + "static/media/TermsConditions@3x.08a96b5e.png";